import Glob from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";

const props = {
	failedPolls: 0,
	pollDefaultFrequency: 5000,
	pollFrequency: 5000,
	pollInterval: false,
	pollLastUpdate: {},
	lastData: { offro: [], cerco: [] },
	firstLaunch: true,
	userid: appLib.currentUser()?.id,
};

props.registration = Glob.register('currentUser', async (u) => {
	if ( u?.id !== props.userid ) {
		props.userid = u?.id;
		props.firstLaunch = true;
		if ( props.userid ) {
			const hidden = (await appLib.api('bacheca/user-hidden' ))?.hidden || [];
			if ( hidden.length > 0 ) {
				Glob.setStatus('hiddenMessages', hidden, true);
			} else {
				const ch = Glob.getStatus('hiddenMessages');
				if ( ch && ch.length > 0 ) {
					await appLib.api('bacheca/user-hidden', { hidden: ch });
				}
			}
		}
		if ( props.pollInterval ) BLib.restartPoll();
	}
});

const poller = async () => {
	let poll;
	let freq = props.pollDefaultFrequency;
	if ( props.userid ) {
		/*  user ping */
		try {
			const u = await appLib.api('auth/refresh-user');
			if ( u?.user?.id ) {
				if ( JSON.stringify(appLib.currentUser()) !== JSON.stringify(u.user) ) {
					appLib.currentUser(u.user);
				}
			}
			if ( u?.poll ) {
				poll = u.poll;
				props.failedPolls = 0;
			}
		} catch (e) {
			// Nothing to do, will retry
		}
	}
	if ( ! poll ) {
		try {
			poll = await appLib.data( 'poll', true);
			props.failedPolls = 0;
		} catch (e) {
			props.failedPolls += 1;
			freq = (1 + Math.min(props.failedPolls,10)/2) * props.pollDefaultFrequency;
			poll = { update: {} };
		}
	}
	if ( poll?.update ) {
		const axles = Object.keys(poll.update);
		for (const axle of axles) {
			if ( poll.update[axle] > (props.pollLastUpdate[axle] ?? 0)) {
				let data;
				try { data = await appLib.data( axle, true); } catch (e) {}
				if ( data ) {
					props.pollLastUpdate[axle] = poll.update[axle];
					BLib.data( axle, data?.messaggi );
				}
			}
		}
		if ( props.firstLaunch && props.pollLastUpdate.offro && props.pollLastUpdate.cerco ) {
			const allids = BLib.data('offro').map( m => m.id).concat( BLib.data('cerco').map( m => m.id) );
			const hidden = (Glob.getStatus('hiddenMessages') || []).filter( m => allids.includes( m ));
			Glob.setStatus('hiddenMessages', hidden, true);
			props.firstLaunch = false;
		}
	}
	if ( freq !== props.pollFrequency ) {
		props.pollFrequency = freq;
		try { clearInterval( props.pollInterval ); } catch ( e ) {}
		props.pollInterval = setInterval( poller, props.pollFrequency);
	}
}

const parseIncomingData = o => {
	if ( Array.isArray(o) ) return o.map( parseIncomingData );
	if ( o && typeof o === 'object' ) {
		Object.keys(o).filter( k => k.includes('multi:')).forEach( k => {
			o[ k.replace( /multi:/, '' ) ] = o[k] ? o[k].split(/\t/) : [];
			delete o[k];
		});
		Object.keys(o).filter( k => k.includes('multin:')).forEach( k => {
			o[ k.replace( /multin:/, '' ) ] = (o[k] ? o[k].split(/\t/) : []).map( x => Number(x) );
			delete o[k];
		});
		Object.keys(o).filter( k => k.match(/^[^:]+:.+/)).forEach( k => {
			const intField = k.replace( /^([^:]+):.+/, "$1" );
			const newField = k.replace( /^[^:]+:/, "" );
			if ( ! o[intField] ) o[intField] = {};
			o[intField][newField] = o[k];
			delete o[k];
		});
		if ( ! o.meta ) o.meta = {};
	}
	return o;
};

const BLib = {

	/**
	 * @function
	 * @param {boolean} [mode]
	 * @return {void}
	 */
	poll: ( mode = false ) => {
		if ( mode ) {
			if ( props.pollInterval ) return;
			props.pollInterval = setInterval( poller, props.pollFrequency);
			setTimeout( poller );
		} else if ( props.pollInterval ) {
			try { clearInterval( props.pollInterval ); } catch ( e ) {}
			delete props.pollInterval;
		}
	},

	/**
	 * @function
	 * @return {void}
	 */
	startPoll: ()=> BLib.poll(true),

	/**
	 * @function
	 * @return {void}
	 */
	stopPoll: ()=> BLib.poll(false),

	/**
	 * @function
	 * @return {void}
	 */
	restartPoll: () => {
		BLib.poll(false);
		BLib.poll(true);
	},

	/**
	 * @function
	 * @param {string} [axle]
	 * @param {Object[]} [data]
	 * @return {Object|void}
	 */
	data: ( axle, data ) => {
		if ( ! axle ) return Glob.clone(props.lastData);
		if ( data ) {
			props.lastData[axle] = parseIncomingData(Glob.clone(data));
			//console.log( axle, props.lastData[axle] );
			Glob.trigger('DatiBacheca-'+axle, props.lastData[axle]);
			return;
		}
		return Glob.clone(props.lastData[axle]);
	},

	hide: ( messageID ) => {
		let hidden = Glob.getStatus('hiddenMessages') || [];
		if ( hidden.includes( messageID ) ) {
			hidden = hidden.filter( v => v !== messageID );
		} else {
			hidden.push( messageID );
		}
		if ( props.userid ) appLib.api('bacheca/user-hidden' , { hidden: hidden });
		Glob.setStatus( 'hiddenMessages', hidden, true );
	},

	hidden: ( messageID ) => (Glob.getStatus('hiddenMessages') || []).includes( messageID ),

	/**
	 * @function
	 * @async
	 * @return {Promise<{messaggi:BachecaMessage[]}>}
	 */
	myAds: async () => {
		const out = await appLib.api('bacheca/my-ads');
		if ( out && typeof out === 'object' ) {
			Object.keys( out ).forEach( k => {
				out[k] = parseIncomingData(out[k]);
			});
		}
		return out;
	},
};

export default BLib;